// extracted by mini-css-extract-plugin
module.exports = {"amountTag":"style_amountTag__3Qr_s"};